<template>
  <div class="main">
    <quick-actions />
    <sales-summary />
    <cash-summary />
    <sales-history />
  </div>
</template>

<script>
import QuickActions from '@/components/quickActions'
import CashSummary from '@/components/cashSummary'
import SalesSummary from '@/components/salesSummary'
import SalesHistory from '@/components/salesHistory'

export default {
  name: 'Dashboard',
  components: {
    QuickActions,
    CashSummary,
    SalesSummary,
    SalesHistory,
  }
}
</script>

<style lang="scss" src="./style.scss" />
